module.exports = __webpack_public_path__ + "static/media/polar-view-logo.f112b0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/polar-view-logo.png
// module id = 958
// module chunks = 0